import { useContext, useEffect } from 'react';
import { GeneratedPPCData } from '@components/dashboard/utils/periodPainConsultation';
import { PPCReportPDFContent } from '@contracts';
import ReportPDFContext from '../components/PeriodPainReport/ReportPDFContext';
import { generatePPCReportPDFContent } from '../utils/generatePPCReportPDFContent';
import { managePPC } from './managePPC';

export const usePpcQuestionnairePdfData = (painReportData: GeneratedPPCData | null) => {
  const { getPublicQuestionnaire } = managePPC().useGetQuestionnaire();
  const { setPdfData } = useContext(ReportPDFContext);

  useEffect(() => {
    const generatePdfData = async () => {
      if (!painReportData) return;
      const questionnaireData = await getPublicQuestionnaire();

      if (!questionnaireData) return;

      try {
        const pdfContent = generatePPCReportPDFContent(
          questionnaireData,
          painReportData.timestampDate,
          painReportData.originalData,
          painReportData.conditions,
          painReportData.painkillers.context
        );

        setPdfData(pdfContent as PPCReportPDFContent);
      } catch (error) {
        console.error('Error generating PDF content:', error);
        setPdfData({} as PPCReportPDFContent);
      }
    };

    generatePdfData();
  }, [painReportData, getPublicQuestionnaire]);
};
